import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, Events } from 'ionic-angular';
import { UserService } from '../services/index';

@Component({
    templateUrl: 'app.html'
})
export class MyApp {
    navIn: boolean = false;
    admin: boolean = false;

    @ViewChild(Nav) nav: Nav;

    constructor(
        protected events: Events,
        protected platform: Platform,
        protected userService: UserService) {
        platform.ready().then(() => {
            this.events.subscribe('login', () => {
                this.userService.isAdmin()
                    .then((admin) => {
                        this.admin = admin;
                    });
            });            
            this.nav.setRoot('calculation-list', {
                type : 'calculations'
            });
        });
    }

    toggleNav() {
        this.navIn = !this.navIn;
    }

    cssClasses() {
        return {
            'nav-in': this.navIn,
            'nav-out': !this.navIn
        }
    }

    openPage(page: string) {
        let params = undefined;

        switch (page) {
            case 'template-list' :
                page   = 'calculation-list';
                params = { type: 'templates' };
                break;
            case 'calculation-list':
                page   = 'calculation-list';
                params = { type: 'calculations' };
                break;
            case 'archive-list':
                page   = 'calculation-list';
                params = { type: 'archive' };
                break;
        }

        this.nav.setRoot(page, params);
    }

    logout() {
        this.userService.logout()
            .then(() => {
                this.nav.setRoot('login');
            }).catch(() => {
                this.nav.setRoot('login');
            });
    }

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts